var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M59 50H5a1 1 0 000 2h54a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M26 10H7a1 1 0 000 2h19a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M26 15H7a1 1 0 000 2h19a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M26 21H12a1 1 0 000 2h14a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M63 2h-4V1a.945.945 0 00-1-1h-7a.945.945 0 00-1 1v1H37.2a1.421 1.421 0 00-.6.2l-5 3.9a1.013 1.013 0 00-.6.9v40l-3.8-2H2V4h25a1 1 0 000-2H1a.945.945 0 00-1 1v43a.945.945 0 001 1h25.5l5.1 2.6a1.3 1.3 0 001 0 1.05 1.05 0 00.5-.9V7.5L37.7 4H50v6H39a1 1 0 000 2h11v3H39a1 1 0 000 2h11v10.8a.875.875 0 00.6.9.6.6 0 00.4.1.908.908 0 00.7-.3l2.8-2.7 2.8 2.7a.913.913 0 001.1.2.961.961 0 00.6-.9V4h3v41H37a1 1 0 000 2h26a.945.945 0 001-1V3a.945.945 0 00-1-1zm-6 23.4l-1.8-1.7a.967.967 0 00-1.4 0L52 25.5V2h5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.38d5aa15dc0046704e98171a711f278f.svg";
export { ForwardRef as ReactComponent };